<template>
    <div class="data-center"> 
        <div class="content content-flex">
            <!-- 左侧内容 -->
            <div class="left">
                <!-- tab -->
                <ul class="left-tab ul-tab">
                    <template v-for="(item, index) in leftTabs">
                        <li :key="item.id" @click="changeLeft(index, 1)" :class="[index === leftIndex ? 'active': 'nomal']">
                           {{item.title}} 
                        </li>
                    </template>
                </ul>
                <!-- 搜索 -->
                <div v-show="leftIndex === 0" class="left-search">
                    <el-input placeholder="请输入内容" v-model="sortName" clearable>
                       <!-- <el-button slot="append" icon="el-icon-search"></el-button> -->
                       <p class="left-search_btn" slot="append">
                           <i class="el-icon-search"></i>
                       </p>
                    </el-input>
                </div>
                <div class="left-tree" :class="{'left-tree1': leftIndex === 1}">
                    <!-- 指标 -->
                    <el-tree 
                        ref="tree"
                        v-show="leftIndex === 0"
                        node-key="id" 
                        :data="indicators" 
                        :props="defaultProps" 
                        :filter-node-method="filterNode"
                        @node-click="handleNodeClick"></el-tree>
                    <!-- 模板  -->
                    <left-template v-show="leftIndex === 1" :rightIndex="rightIndex"></left-template>
                </div>
            </div>
            <!-- 右侧内容 -->
            <div class="right">
                <ul class="right-tab ul-tab">
                    <template v-for="(item, index) in rightTabs">
                        <li :key="item.id" @click="changeRight(index)" :class="[index === rightIndex ? 'active': 'nomal']">
                           {{item['title'+leftIndex]}}
                        </li>
                    </template>
                </ul>
                <div class="right-content" ref="rightContent">
                    <div v-show="rightIndex === 0">              
                        <!-- 选择指标 -->
                        <check-table v-if="leftIndex === 0" class="right-table" :tableHeight="tableHeight" @changeLeft="changeLeft"></check-table>
                        <!-- 我的模板 -->
                        <my-table v-show="leftIndex === 1"  class="right-table" :tableHeight="tableHeight" @changeLeft="changeLeft"></my-table>
                    </div>
                    <!-- 表格数据 -->
                    <data-table v-if="rightIndex === 1" class="right-table" :tableHeight="tableHeight"></data-table>
                    <!-- 图形 -->
                    <echarts-line v-if="rightIndex === 2" :tableHeight="tableHeight"></echarts-line>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CheckTable from "./components/checkTable"
import DataTable from './components/dataTable'
import EchartsLine from './components/echartsLine'
import MyTable from './components/myTable'
import LeftTemplate from './components/leftTemplate'
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
    components: { CheckTable, DataTable, EchartsLine, MyTable, LeftTemplate },
    data() {
        return {
            // 左侧导航
            leftTabs: [ 
                { id: 1, title: "指标" }, 
                { id: 2, title: "模板"}
            ],
            sortName: "",  //指标搜索条件
            data: [
                {
                    label: '一级 1',
                    children: [{
                        label: '二级 1-1',
                        children: [{
                            label: '三级 1-1-1'
                        }]
                    }]
                }, 
                {
                    label: '一级 2',
                    children: [
                        {
                        label: '二级 2-1',
                        children: [{
                            label: '三级 2-1-1'
                        }]
                    }, {
                        label: '二级 2-2',
                        children: [{
                            label: '三级 2-2-1'
                        }]
                    }]
                }, 
                {
                    label: '一级 3',
                    children: [{
                        label: '二级 3-1',
                        children: [{
                            label: '三级 3-1-1'
                        }]
                    },{
                        label: '二级 3-2',
                        children: [{
                            label: '三级 3-2-1',
                            children: [{
                                label: '四级 3-2-1-1'
                            },{
                                label: '四级 3-2-1-2'
                            }]
                        }]
                    }]
                }, 
                {
                    label: '一级 4',
                    children: [{
                        label: '二级 4-1',
                        children: [{
                            label: '三级 4-1-1'
                        }]
                    },{
                        label: '二级 4-2',
                        children: [{
                            label: '三级 4-2-1',                            
                            children: [{
                                label: '四级 4-2-1-1',
                                label: '四级 4-2-1-2',
                                label: '四级 4-2-1-3',
                                label: '四级 4-2-1-4',
                                
                            },{
                                label: '三级 4-2-2',                            
                            children: [{
                                label: '四级 4-2-2-1',
                                label: '四级 4-2-2-2',
                                label: '四级 4-2-2-3',
                                label: '四级 4-2-2-44-2-2-44-2-2-44-2-2-44-2-2-44-2-2-44-2-2-4',
                                
                            }]
                            },{
                                label: '三级 4-2-3'
                            },{
                                label: '三级 4-2-4'
                            }]
                        }]
                    }]
                }
            ],
            defaultProps: {
                children: 'children',
                label: 'name'
            },
            // 右侧导航
            rightTabs: [ 
                { id: 1, title0: "选择指标", title1: "我的模板" },
                { id: 2, title0: "表格数据", title1: "表格数据" },
                { id: 3, title0: "图形", title1: "图形" }
            ],
            rightIndex: 0,
            // table滚动高度
            tableHeight: 0
        }
    },
    computed: {
        ...mapGetters(["leftIndex", "indicators", "checkIndicators", "templateInfo"])
    },
    watch: {
        sortName(val) {
            this.$refs.tree.filter(val);
            if (!val) {
                this.$nextTick(() => {
                    this.allExpand(false)
                })
            }
        }
    },
    created() {
        const rLoading = this.openLoading();
        this.GetIndicators().then(res => {
            this.GetTemplate()
            rLoading.close()
        }).catch(() => {
            rLoading.close()
        })
    },
    mounted() {
        this.initHeight()
    },
    methods: {
        ...mapMutations(["SET_CHECK_INDICATORS", "SET_LEFT_TABLE"]),
        ...mapActions(["GetIndicators", "GetTemplate", "GetTemplateInfo", "GetTargetTable"]),
        // 初始化table高度
        initHeight() {
            let domH = window.getComputedStyle(this.$refs.rightContent).height
            const domArr = domH.split("px")
            this.tableHeight = Number(domArr[0]) - 54
        },
        // 切换左侧
        changeLeft(index, type) {
            if (this.indicators.length === 0) return;
            if (index === 1) {
                if (!type && this.templateInfo.id) {
                    this.GetTemplateInfo(this.templateInfo)
                }
            }
            this.SET_LEFT_TABLE(index)
        },
        // 选择指标
        handleNodeClick(data) {
            if(data.datasourceId) {
                if (this.checkIndicators.length >= 30) {
                    this.$message.warning("最多可选择30个数据指标")
                    return;
                }
                this.SET_CHECK_INDICATORS({row: data, type: 1})
            }
        },
        // 搜索指标
        filterNode(value, data) {
            if (!value) return true;
            return data.name.indexOf(value) !== -1;
        },
        // 展开收缩树
        allExpand(isExpand) {
            const that = this;
            const treeList = this.indicators;
            for (let i = 0; i < treeList.length; i++) {
                that.$refs.tree.store.nodesMap[treeList[i].id].expanded = isExpand;
            }
        },
        // 切换右侧
        changeRight(index) {
            if (this.indicators.length === 0) return;
            if (this.rightIndex === index) return;
            this.rightIndex = index;
        },
        loginPage() {
            this.$message.error("未登录或登录状态已过期，请重新登录")
            const fullPath = this.$route.fullPath
            this.$router.push(`/login?redirect=${fullPath}`)
        }
    }
}
</script>

<style>
*::-webkit-scrollbar-track-piece {
    background:#F5F5F5;
}
*::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}
*::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 20px;
}
.scrollbarHide::-webkit-scrollbar{display: none}
.scrollbarShow::-webkit-scrollbar{display: block}
</style>

<style lang="less" scoped>
::v-deep .el-input__inner:focus{
    border-color:#D3131A;
}
::v-deep .el-input__suffix{
    top: -4px;
}
::v-deep .el-tree {
    background: none;
}
::v-deep .el-tree>.el-tree-node {
  display: inline-block;
  min-width: 100%;
}
::v-deep .el-tree > el-tree-node__content{
    display: none;
}
.data-center {
    width: 100%;
    .content {
        width: 1200px;
        margin: 0 auto;
    }
    .content-flex {
        display: flex;
        padding: 10px;
        border: 1px solid #ccc;
        box-sizing: border-box;
        min-height: 400px;
        height: calc(100vh - 220px);
        .ul-tab {
           display: flex;
           li {
                color: #222;
                text-align: center;
                cursor: pointer;
           } 
        }
        .left {
            width: 260px;
            display: flex;
            flex-direction: column;
            ul {
                li {
                    width: 50%;    
                    background: #F2F2F2;
                    height: 32px;
                    line-height: 32px;
                }
                .active {
                    background-color: #D3131A;
                    color: #fff;
                }
                .nomal:hover {
                    opacity: 0.8;
                }
            }
            .left-search {
                margin-top: 4px;
                box-sizing: border-box;
                padding: 10px;
                border: 1px solid #D3131A;
                border-bottom: 0px;
                .left-search_btn {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: #fff;
                    cursor: pointer;
                    i {
                        color: #D3131A;
                    }
                }
                ::v-deep .el-input-group__append {
                    background: #fff;
                    border-top-right-radius: 20px;
                    border-bottom-right-radius: 20px;
                    border: 1px solid #D3131A;
                    border-left: 0px;
                }
                ::v-deep .el-input {
                    height: 32px;
                }
                ::v-deep .el-input__inner {
                    height: 32px;
                    border-top-left-radius: 20px;
                    border-bottom-left-radius: 20px;
                }
            }
            .left-tree {
                flex: 1;
                border: 1px solid #D3131A;
                overflow: auto;
                overflow: -webkit-overlay; 
            }
            .left-tree1 {
                margin-top: 4px;
            }
        }
        .right {
            // flex: 1;
            margin-left: 10px;
            width: 906px;
            display: flex;
            flex-direction: column;
            .right-tab {
                display: flex;
                margin-left: 26px;
                li {
                    width: 90px;
                    box-sizing: border-box;
                    height: 36px;
                    line-height: 36px;
                    border: 1px solid rgba(0, 0, 0, 0);
                }
                li:hover {
                    color: #D3131A;
                }
                .active {
                    color: #D3131A;
                    border-top: 1px solid #D3131A;
                    border-left: 1px solid #D3131A;
                    border-right: 1px solid #D3131A;
                    position: relative;
                    &::before {
                        content: "";
                        position: absolute;
                        left: 0px;
                        bottom: -1px;
                        right: 0px;
                        height: 1px;
                        background: rgb(254, 246, 231);
                        z-index: 9;
                    }
                }
            }
            .right-content {
                flex: 1;
                border: 1px solid #D3131A;
                margin-top: -1px;
                .right-table {
                    padding: 0 15px;
                }
            }
        }
    }
}
</style>